<template>
  <div class="not-found-pages">
    <HeaderOperator />

    <div class="dashboard-shell">
      <div class="section-heading">
        <span class="section-heading__eyebrow">Acceso</span>
        <h1 class="dashboard-title">{{ event.name || 'Control de accesos' }}</h1>
        <p class="dashboard-subtitle">
          Escaneo, validacion manual y control operativo del evento.
        </p>
      </div>

      <div class="flex xs12">
        <va-card class="dashboard-panel" style="overflow-x: auto;">
          <va-card-title>Opciones del evento</va-card-title>
          <va-card-content>
            <div class="row">
              <div class="flex xs12">
                <va-tabs v-model="value" grow style="width: 100%;">
                  <template #tabs>
                    <va-tab v-for="title in ['Acceso Automático', 'Acceso Manual']" :key="title" :name="title">
                      {{ title }}
                    </va-tab>
                  </template>
                </va-tabs>
              </div>
            </div>
          </va-card-content>
        </va-card>
      </div>

      <QrReader v-show="value === 'Acceso Automático'" v-if="!showLoading" :event="event" style="padding-top: 20px; padding-bottom: 20px;" />
      <AssistanceList v-show="value === 'Acceso Manual'" v-if="!showLoading" :event="event" style="padding-top: 20px; padding-bottom: 20px;" />
    </div>
  </div>
</template>

<script>
import { apiService } from '../../common/api.services.js'
import QrReader from '@/pages/operator/QrReader.vue'
import AssistanceList from './AssistanceList.vue'
import HeaderOperator from '../../components/HeaderOperator.vue'

export default {
  name: 'EventOperatorView',

  components: {
    QrReader,
    HeaderOperator,
    AssistanceList,
  },

  props: {
    slug: {
      required: true,
    },
  },

  data() {
    return {
      value: 'Acceso Manual',
      event: {},
      showLoading: false,
    }
  },

  created() {
    this.getEvent()
  },

  methods: {
    getEvent() {
      this.showLoading = true
      apiService(`/api/events-basic/${this.slug}/`).then((data) => {
        this.event = data
        this.showLoading = false
      })
    },
  },
}
</script>

<style>
</style>
